<template>
  <div class="referral center-just">
    <div class="column">
      <!-- <el-image
        :src="$domain + 'static/noten/website/home/index1_title3_img.png'"
        style="width: 260px;height: 82px;align-self: center;cursor: pointer;"
      ></el-image> -->
      <div>
        <div class="center-just box-title" style="caret-color: transparent;">
          特色教学法
        </div>
        <!-- <div class="center-just title-info">
          信息学体系全覆盖，确保学习连贯性
        </div> -->
      </div>
      <div class="images space">
        <div
          v-for="(i, index) in 5"
          :key="index"
          :style="{
            backgroundImage:
              'url(' +
              ($domain +
                'static/noten/website/home/index1_box3_img' +
                (index + 6) +
                '.png') +
              ')'
          }"
          style="background-size: 100% 100%;width: 238px;caret-color: transparent;cursor: pointer;"
          :class="{ 'hover-scale': index + 1 == isHovering }"
          class="center"
          @mouseover="bigImage(index + 1)"
          @mouseout="smallImage(index + 1)"
        >
          <div
            style="background-color: aqua;width: 72%;height: 55%;margin-top: 155px;"
          >
            <div class="center info-content">游戏式学习法</div>
            <div style="margin-top: 10px;" class="content center">
              将编程教学与游戏融合，让儿童在玩游戏的过程中学习编程。例如，使用可视化编程工具来创建有趣的小游戏，让儿童在游戏中学习编程的基础知识。
              让儿童在游戏中学习编程的基础知识。
            </div>
          </div>
        </div>
        <!-- <el-image
          v-for="(i, index) in 5"
          :key="index"
          :src="
            $domain +
              'static/noten/website/home/index1_box3_img' +
              (index + 6) +
              '.png'
          "
          style="cursor: pointer;padding: 0;"
          :class="{ 'hover-scale': index + 1 == isHovering }"
          @mouseover="bigImage(index + 1)"
          @mouseout="smallImage(index + 1)"
        >
          测试一下
        </el-image> -->
        <!-- <div>测试一下</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import TransitionText from "@/components/TransitionText.vue";
export default {
  components: { TransitionText },
  data() {
    return {
      isHovering: 0
    };
  },
  methods: {
    bigImage(index) {
      this.isHovering = index;
    },
    smallImage(index) {
      this.isHovering = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.hover-scale {
  transform: scale(1.1);
  transition: transform 0.1s ease-in-out;
}

.referral {
  height: 800px;
  width: 100%;
  background-color: #fafbff;
  .column {
    width: 63%;
  }
  .images {
    // width: 62.5%;
    margin-top: 50px;
    height: 440px;
  }
}

.box-title {
  height: 46px;
  font-size: 46px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1a1a1a;
}

.title-info {
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin-top: 33px;
}
.images {
  .center {
    .info-content {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    .content {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: #6b7182;
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/programming/box/box3.vue